module.exports = __webpack_public_path__ + "static/img/new-33.fbf13676.jpg";